<template>
  <v-footer  app dark  padless>
    <v-card class="flex" flex flat tile>
      <!-- <v-card-title class="teal">
        <strong class="subheading">Get connected with us on social networks!</strong>
        <v-spacer></v-spacer>

      <v-btn v-for="icon in icons" :key="icon" class="ms-4" dark icon>
          <v-icon size="24px">{{ icon }}</v-icon>
        </v-btn>
      </v-card-title> -->

      <v-card-actions class="grey darken-3 justify-center">
        {{ new Date().getFullYear() }} — <strong>Pivot3</strong>
      </v-card-actions>
    </v-card>
  </v-footer>
</template>

<script>
  export default {
     name: 'Footer',
    data: () => ({
      icons: [
        'fab fa-facebook',
        'fab fa-twitter',
        'fab fa-google-plus',
        'fab fa-linkedin',
        'fab fa-instagram',
      ],
    }),
  }
</script>

<style scoped>
</style>
